import React, { useEffect, useMemo, useState } from "react";
import { REACT_APP_ACR_API_BASE_URL, REACT_APP_ACR_API_PROTOCOL } from "../../utlities/core.constants";

export const VendorContext = React.createContext({})

// eslint-disable-next-line no-unused-vars
export const VendorConsumer = VendorContext.Consumer;

// eslint-disable-next-line react/prop-types
export function VendorProvider({children}) {
  // const [Vendor, setVendor] = useState({});
  const [vendors, setVendors] = useState([]);

  const fetchVendors = () => {
    fetch(`${REACT_APP_ACR_API_PROTOCOL}://${REACT_APP_ACR_API_BASE_URL}/api/vendor/all`)
      .then(response => response.json())
      .then(data => {
        setVendors(data);
      })
      .catch(error => {
        // eslint-disable-next-line no-console
        console.error('Error fetching Vendors:', error);
      });
  };

  useEffect(() => {
    fetchVendors();
  }, []);

  // eslint-disable-next-line no-unused-vars
  const resetVendors = () => {
    setVendors([]);
  };

  const contextValue = useMemo(() => ({ vendors, setVendors, fetchVendors }), [vendors, setVendors]);

  return (
    <VendorContext.Provider value={contextValue} >
      {children}
    </VendorContext.Provider>
  );
}
export default VendorContext;
